import { connect } from 'react-redux';
import {
  getMetainf,
  getProjectZoneId,
  getRevenueEvents,
  getRevenueExecuteTime,
} from '../../reducers/analyticsApp';
import EventTableView from '../../components/table/EventTableView';

const mapStateToProps = (state) => ({
  zoneId: getProjectZoneId(state),
  result: getRevenueEvents(state) || [],
  executeTime: getRevenueExecuteTime(state),
  metainf: getMetainf(state),
});

export default connect(mapStateToProps)(EventTableView);
